$rise_radio_demo $mol_example_small
	sub /
		<= Radio $rise_radio
			options /
				\Option1
				\Option2
				\Option3
	tags /
		\radio
	aspects /
		\Widget
